import {
  MissingCompanyStakeholderKycDocumentType,
} from '@generated/graphql';
import {BaseModel} from '@shared/models/base.model';
import {OfficerRequiredDocument} from "@modules/officer/models/officer-required-document.model";
import {CompanyStakeholder} from "@modules/company/models/company-stakeholder.model";
import {companyStakeholderFactory} from "@modules/company/factories/company-stakeholder.factory";

export class MissingCompanyStakeholderKycDocument extends BaseModel implements MissingCompanyStakeholderKycDocumentType {
  stakeholder: CompanyStakeholder;
  missingKycDocuments: OfficerRequiredDocument[];
  unallocatedCapitalRemaining: number

  constructor(state: MissingCompanyStakeholderKycDocumentType) {
    super(state);
    this.stakeholder = companyStakeholderFactory.tryCreating(state.stakeholder)
  }

  getModelName(): string {
    return "";
  }
}
